import { useEffect } from 'react'

import { setDirty } from 'store/StructuralContext/structuralSlice'
import { useDispatch } from 'store/store'

/**
 * Tracks a "boolean" state and automatically updates Redux with information necessary for the "useNavigationPrompt" hook.
 *
 * @param when - boolean, true if navigation should be blocked
 */
export function useNavBlocker(when: boolean) {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setDirty(when))

    return () => {
      dispatch(setDirty(false))
    }
  }, [when, dispatch])
}
